module.exports = __webpack_public_path__ + "static/img/logonkm.6e73be0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/km/logonkm.png
// module id = zL4y
// module chunks = 2